import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Seo } from '@layout';
import { HotelRoomBlocksHeroSection } from '@sections/hotel-room-blocks';
import { hotelRoomBlocksPageData } from '@data-ts/pages/hotel-room-blocks';
import { PersonalTravelConciergeSection } from '@sections/hotel-room-blocks/PersonalTravelConcierge/PersonalTravelConciergeSection';
import { RiskFreeReservationsSection } from '@sections/hotel-room-blocks/RiskFreeReservations/RiskFreeReservationsSection';
import { ColoredBlockSection } from '@sections/shared/ColoredBlockSection';
import { faqQuestionsData } from '@data-ts/components/FaqQuestions';

import { FaqList } from '@components/FaqList';
import { ExpertRecommendationsSection } from '@sections/hotel-room-blocks/ExpertRecommendations/ExpertRecommendations';
import { ExclusiveGroupRatesSection } from '@sections/hotel-room-blocks/ExclusiveGroupRatesSection/ExclusiveGroupRatesSection';
import { StreamlineCommunicationSection } from '@sections/hotel-room-blocks/StreamlineCommunication/StreamlineCommunication';
import { WeddingWebsiteSection } from '@sections/hotel-room-blocks/WeddingWebsite/WeddingWebsite';
import { PremiumPerksUpgradesSection } from '@sections/hotel-room-blocks/PremiumPerksUpgrades/PremiumPerksUpgradesSection';
import { getCreateEventUrl } from '@utils/urlHelpers.util';
import { useQueryParams } from '@hooks/useQueryParams';
import { GetStartedButtonProvider } from '@components/GetStartedButton/GetStartedButtonProvider';
import { TextContentBlock } from '@sections/hotel-room-blocks/TextContentBlock/TextContentBlock';

const HOTEL_ROOM_BLOCKS_PAGE = 'hotel-room-blocks';
const PARTNER_URL = 'https://withjoy.typeform.com/to/eZKeFc3j#partner=';

const HotelRoomBlocks = () => {
  const partner = useQueryParams()['partner'];
  const [href, setHref] = useState(getCreateEventUrl(HOTEL_ROOM_BLOCKS_PAGE));

  useEffect(() => {
    if (partner) {
      setHref(`${PARTNER_URL}${partner}`);
    }
  }, [partner]);

  return (
    <GetStartedButtonProvider href={href}>
      <Layout
        page={HOTEL_ROOM_BLOCKS_PAGE}
        isTransparentHeader={true}
        transparentJoyLogoColor="mono7"
        transparentHeaderButtonVariant="defaultPrimeWeddingWebsites"
      >
        <Seo
          title={hotelRoomBlocksPageData.seo.title}
          description={hotelRoomBlocksPageData.seo.content}
          canonicalURL={'https://withjoy.com/hotel-room-blocks/'}
        />
        <HotelRoomBlocksHeroSection />
        <PersonalTravelConciergeSection />
        <RiskFreeReservationsSection />
        <ExclusiveGroupRatesSection />
        <PremiumPerksUpgradesSection />
        <StreamlineCommunicationSection />
        <ExpertRecommendationsSection />
        <WeddingWebsiteSection />
        <ColoredBlockSection
          isLeftAligned
          backgroundColor="white"
          sideHeaderText={'Frequently <br/> Asked <br/> Questions'}
          sectionId="Hotel_Room_Blocks_FAQ"
          isToggleNeeded={false}
        >
          <FaqList accordion={true} questionNodes={[...faqQuestionsData.hotelRoomBlocks]} color="neutra6" />
        </ColoredBlockSection>
        <TextContentBlock />
      </Layout>
    </GetStartedButtonProvider>
  );
};

export default HotelRoomBlocks;
